module.exports = __webpack_public_path__ + "img/142.10.61cb43dc.png";